import React, { Component } from 'react';
import PropTypes from 'prop-types'
import ReactPlayer from 'react-player'
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import ReactTooltip from 'react-tooltip';
//import Switch from "react-switch";
//import testData from './testData.json';
// import transcribeData from './transcriptData.json';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
//import Amplify, { API, Auth } from 'aws-amplify'
//import awsconfig from '../../aws-exports';
//API.configure(awsconfig);
//Auth.configure(awsconfig);
//import BeatLoader from "react-spinners/BeatLoader";



class Video extends Component {

  constructor(props) {
    super(props);
    this.confidenceCutOff = 0.5
    this.sortByConfidence = false
    this.aiData = []
    this.asset = {}
    this.marklogicData = []
    this.videoDuration = 0
    this.sortBy = "Confidence"
    this.state = {
      aiData: [],
      filename: "test",
      showTimeline: true,
      rangeStartTime: 0,
      rangeEndTime: 0,
      rangeSelected: 0,
      videoDuration: 0,
      asset: { metadata: { fileSize: {} } },
      canvases: <></>,
      transcriptData: "loadingData",
      transcriptTags: <></>,
      transcriptLangaguesText: [],
      videoLabels: "loadingData",
      timeLineLabels: [],
      played: 0,
      selectedArray: [],
      segmentData: [],
      labelsOnScreen: [],
      labelObjects: [],
      labelsDetailed: <></>,
      labelsOnScreenComps: <></>,
      segmentLabels: <></>,
      timelineHeight: 20,
      transcriptBoxData: [],
      transcriptionText: "",
    }
  }


  transcriptWriter(playedSeconds) {
    let transcriptionText = this.state.transcriptionText
    transcriptionText = ""
    let boxToDisplay = this.state.transcriptBoxData.find(o => o.startTime <= playedSeconds && o.endTime + 1 >= playedSeconds)
    if (boxToDisplay) {
      transcriptionText = boxToDisplay.words.filter(o => parseFloat(`${o.startTime.seconds}.${o.startTime.nanos}`) < playedSeconds).map(o => o.word).join(' ')
    }
    return transcriptionText
  }
  sec2time(timeInSeconds) {
    var pad = function (num, size) { return ('000' + num).slice(size * -1); },
      time = parseFloat(timeInSeconds).toFixed(3),
      hours = Math.floor(time / 60 / 60),
      minutes = Math.floor(time / 60) % 60,
      seconds = Math.floor(time - minutes * 60),
      milliseconds = time.slice(-3);

    return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2) + '.' + pad(milliseconds, 2);
  }

  buildDetailedLabels() {
    let labelsDetailed = []

    let videoDuration = this.player.getDuration()


    this.state.labelObjects.forEach(object => {
      // console.log({ object })
      let segments = []
      let grids = []




      object.segments.forEach((segment, index) => {
        let barStart = (segment.startTime / videoDuration) * 100
        let barEnd = (segment.endTime / videoDuration) * 100
        let barWidth = (barEnd - barStart)

        segments.push(
          <div className="ems_timeline-tag-marker" onClick={this.gotoSingleLabel.bind(this, (segment.startTime / videoDuration))} style={{ width: `${barWidth}%`, left: `${barStart}%` }}>
          </div>
        )

        grids.push(

          <div className="ems_grid-item">
            <div className="ems_item_label"></div>
          </div>,
          <div className="ems_grid-item">
            <div className="ems_item_content">
              <div className="ems_text ems_time">{this.sec2time(segment.startTime)}</div>
            </div>
          </div>,
          <div className="ems_grid-item">
            <div className="ems_item_content">
              <div className="ems_text ems_time">{this.sec2time(segment.endTime)}</div>
            </div>
          </div>,
          <div className="ems_grid-item">
            <div className="ems_item_content">
              <div className="ems_text ems_time"> {(segment.confidence * 100).toFixed(1)}%</div>
            </div>
          </div>

        )
      })

      labelsDetailed.push(
        <div className="ems_group">
          <div className="ems_inner">
            <div className="ems_group-item">
              <div className="ems_grid ems_grid-4">
                <div className="ems_grid-item ems_grid-item-c4">
                  <div className="ems_item_label">{object.description}</div>
                </div>
                <div className="ems_grid-item ems_grid-item-c4">
                  <div className="ems_timeline-wrapper">
                    <div className="ems_timeline-tag">
                      {segments}
                    </div>
                  </div>
                </div>
                {grids}
              </div>
            </div>
          </div>
        </div>
      )
    })

    let returnedData = <div className="ems_overlay ems_overlay_tags is-open">
      <div className="ems_control-item-header" onClick={this.toggleClass.bind(this, 'ems_tools_Block', 'ems_furtherDetails_tags')}>
        <div className="ems_icon ems_icon_back"></div>Timeline tags detail
      </div>
      <div className="ems_group">
        <div className="ems_inner">
          <div className="ems_group-item">
            <div className="ems_description">Here you can take a look at tags in more detail</div>
          </div>
          <div className="ems_group-item">
            <div className="ems_grid ems_grid-4">
              <div className="ems_grid-item">
                <div className="ems_item_label"></div>
              </div>
              <div className="ems_grid-item">
                <div className="ems_item_label">
                  <div className="ems_text">Start time</div>
                </div>
              </div>
              <div className="ems_grid-item">
                <div className="ems_item_label">
                  <div className="ems_text">End time</div>
                </div>
              </div>
              <div className="ems_grid-item">
                <div className="ems_item_label">
                  <div className="ems_text">Confidence</div>
                </div>
              </div>
            </div>
          </div>
          {labelsDetailed}



        </div>
      </div>

    </div>






    this.setState({ labelsDetailed: returnedData }, () => {
      //ReactTooltip.rebuild()
    })




  }

  buildDetailedTranscript() {
    let transcriptBoxData = []
    let transcriptTags = []

    //console.log({ stateTranscript: this.state.transcriptData })
    if (this.state.transcriptData != "nodata" && this.state.transcriptData != "loadingData") {
      this.state.transcriptData.speechTranscriptions.forEach(block => {
        if (block.alternatives[0].transcript) {
          let words = block.alternatives[0].words
          let object = {
            startTime: parseFloat(`${words[0].startTime.seconds}.${words[0].startTime.nanos}`),
            endTime: parseFloat(`${words[words.length - 1].startTime.seconds}.${words[words.length - 1].startTime.nanos}`),
            words: words,
            transcript: block.alternatives[0].transcript
          }
          //  console.log({ block, object })


          let grp = <div className="ems_group-item">
            <div className="ems_grid ems_grid-4">
              <div className="ems_grid-item">
                <div className="ems_item_label">Start</div>
                <div className="ems_item_content">
                  <div className="ems_text ems_time">{`${this.sec2time(object.startTime)}`}</div>
                </div>
                <div className="ems_item_label">Language</div>
                <div className="ems_item_content">
                  <div className="ems_text">{this.getlanguageCode(block.languageCode)}</div>
                </div>
              </div>
              <div className="ems_grid-item">
                <div className="ems_item_label">End</div>
                <div className="ems_item_content">
                  <div className="ems_text ems_time">{`${this.sec2time(object.endTime)}`}</div>
                </div>

                <div className="ems_item_label">Confidence</div>
                <div className="ems_item_content">
                  <div className="ems_text">{(block.alternatives[0].confidence * 100).toFixed(1)}%</div>
                </div>
              </div>
              <div className="ems_grid-item ems_grid-item-c2">
                <div className="ems_item_label">Transcript</div>
                <div className="ems_item_content">
                  <div className="ems_text">{block.alternatives[0].transcript}</div>
                </div>
              </div>
            </div>

          </div>


          transcriptTags.push(grp)
          transcriptTags.push(<div className="hr" />)
          transcriptBoxData.push(object)
        }
      })
    }


    let returnedData = <div className="ems_overlay ems_overlay_tags is-open">
      <div className="ems_control-item-header" onClick={this.toggleClass.bind(this, 'ems_tools_Block', 'ems_furtherDetails_tags')}>
        <div className="ems_icon ems_icon_back"></div>Additional details
      </div>
      <div className="ems_group">
        <div className="ems_inner">
          <div className="ems_group-item">
            <div className="ems_description">Here you can take a look at tags in more detail</div>
          </div>
          {transcriptTags}

        </div>
      </div>
    </div>

    this.setState({ labelsDetailed: returnedData }, () => {
      //  ReactTooltip.rebuild()
    })
    //   console.log({ selectedArray: this.state.selectedArray })



  }


  videoProgress(data) {
    let labelsOnScreen = []
    let playTime = (data.played * 100)
    let labelsOnScreenComps = []
    let transcriptionText = this.transcriptWriter(data.playedSeconds)
    // console.log({player: this.player.getCurrentTime()})
    if (this.player.getCurrentTime() >= (this.state.rangeEndTime)) {
      this.player.seekTo(this.state.rangeStartTime)
      console.log({ playTime, end: this.state.rangeEndTime })
    }



    // light up labels
    this.state.segmentData.forEach(function (obj) {
      if (obj.startTime < playTime && obj.endTime > playTime) {
        labelsOnScreen.push(obj.name)
      }
    })
    labelsOnScreen.forEach(label => {
      labelsOnScreenComps.push(
        <div className="labelOnScreen">{label}</div>
      )
    })
    this.setState({ played: playTime, labelsOnScreen, labelsOnScreenComps, transcriptionText }, () => {
      try {
        window.updateLabelTags(labelsOnScreen)
        this.buildTranscribeData()
      } catch (error) {

      }
    });
  }

  ref = player => {
    this.player = player
    window.player = player
  }

  // componentDidUpdate(prevProps, prevState) {
  //   //console.log({ asset: this.props.asset })
  //   if (prevProps.aiData !== this.props.aiData) {
  //     console.log("WE ARE HERE")
  //     let videoLabels = "nodata"
  //     let transcriptData = "nodata"
  //     console.log('something prop has changed.')

  //     this.props.aiData.forEach(data => {
  //       if (data.uri.includes("googleVision-VideoTranscribe.json")) {
  //         transcriptData = data.content
  //       } else if (data.uri.includes("googleVision-VideoLabels.json")) {
  //         videoLabels = data.content
  //       }
  //       console.log(data.uri)
  //     })

  //     this.setState({
  //       videoLabels,
  //       transcriptData,
  //       asset: this.props.asset,
  //     }, () => {
  //       console.log({ stateAsset: this.state.asset })
  //       this.buildLabelDataData()
  //       this.buildTranscribeData()

  //     });
  //   }
  // }

  setVideoStates() {
    console.log("DFKLJHFSDKJFHKSDJFHSKDJHFKSJDFKJSDHFKJDSHFKJSDHFKJSDHFKJSDHFKJSDHFKJSHFKJSHFKJSHFKJSHFKJSHFKJSFJKSHFKJSHFJKSHFKJHDS")
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.marklogicData !== this.props.marklogicData) {
      let videoLabels = "nodata"
      let transcriptData = "nodata"
      console.log('something prop has changed.')

      this.props.marklogicData.forEach(data => {
        if (data.uri.includes("googleVision-VideoTranscribe.json")) {
          transcriptData = data.content
        } else if (data.uri.includes("googleVision-VideoLabels.json")) {
          videoLabels = data.content
        }
        console.log(data.uri)
      })

      this.setState({
        videoLabels,
        transcriptData,
        //  asset: this.props.asset,
      }, () => {

      });
    }
  }




  componentDidMount() {
    window.addTagToTimeline = this.addTagToTimeline.bind(this)
    //  window.setVideoStates = this.setVideoStates(this)
    console.log("DFKLJHFSDKJFHKSDJFHSKDJHFKSJDFKJSDHFKJDSHFKJSDHFKJSDHFKJSDHFKJSDHFKJSHFKJSHFKJSHFKJSHFKJSHFKJSFJKSHFKJSHFJKSHFKJHDS")
    console.log(this.props.marklogicData)

    this.setState({ aiData: this.props.marklogicData })
    //    console.log({res})
    let videoLabels = "nodata"
    let transcriptData = "nodata"
    //  console.log('something prop has changed.')

    // this.props.marklogicData.forEach(data => {
    //   if (data.uri.includes("googleVision-VideoTranscribe.json")) {
    //     transcriptData = data.content
    //   } else if (data.uri.includes("googleVision-VideoLabels.json")) {
    //     videoLabels = data.content
    //   }
    //   //    console.log(data.uri)

    //   this.setState({
    //     videoLabels,
    //     transcriptData,
    //   }, () => {
    //     this.buildLabelDataData()
    //     this.buildTranscribeData()

    //   });
    // })
    console.log("hello")

  }

  addTagToTimeline(html, deleting) {
    let array
    if (deleting) {
      console.log("should delete here")
      array = Array.from(this.state.timeLineLabels).filter(function (item) {
        console.log({ item, html })
        return item.props.id !== html
      })
    } else {
      array = Array.from(this.state.timeLineLabels).concat(html)
    }
    this.setState({ timeLineLabels: array })
  }

  transcriptSeekTo(block) {
    let seekTo = `${block.alternatives[0].words[0].startTime.seconds}.${block.alternatives[0].words[0].startTime.nanos}`
    this.player.seekTo(parseFloat(seekTo))
  }

  buildTranscribeData() {
    let transcriptBoxData = []
    let transcriptTags = []
    let videoDuration = this.player.getDuration()
    let transcriptLangaguesText = new Set()
    //console.log({ stateTranscript: this.state.transcriptData })
    if (this.state.transcriptData != "nodata" && this.state.transcriptData != "loadingData") {
      this.state.transcriptData.speechTranscriptions.forEach(block => {
        if (block.alternatives[0].transcript) {
          let words = block.alternatives[0].words
          let object = {
            startTime: parseFloat(`${words[0].startTime.seconds}.${words[0].startTime.nanos}`),
            endTime: parseFloat(`${words[words.length - 1].startTime.seconds}.${words[words.length - 1].startTime.nanos}`),
            words: words,
            transcript: block.alternatives[0].transcript
          }
          //  console.log({ block, object })
          transcriptLangaguesText.add(this.getlanguageCode(block.languageCode))

          const showing = (this.state.played > object.startTime) && (this.state.played < object.endTime)
          //    console.log({ played: this.state.played, startTime: (object.startTime), endTime: (object.endTime), videoDuration: videoDuration, showing })
          let className = showing ? 'ems_tag on_timeline active' : 'ems_tag';



          transcriptTags.push(
            <div className={className} onClick={this.transcriptSeekTo.bind(this, block)}>{block.alternatives[0].transcript} </div>
          )
          transcriptBoxData.push(object)
        }
      })
      this.setState({ transcriptBoxData, transcriptTags, transcriptLangaguesText: Array.from(transcriptLangaguesText) });
      //  console.log({ transcriptBoxData })
    }

  }

  getlanguageCode(code) {
    let languageCode = {
      "af": "Afrikaans",
      "af-ZA": "Afrikaans (South Africa)",
      "ar": "Arabic",
      "ar-AE": "Arabic (U.A.E.)",
      "ar-BH": "Arabic (Bahrain)",
      "ar-DZ": "Arabic (Algeria)",
      "ar-EG": "Arabic (Egypt)",
      "ar-IQ": "Arabic (Iraq)",
      "ar-JO": "Arabic (Jordan)",
      "ar-KW": "Arabic (Kuwait)",
      "ar-LB": "Arabic (Lebanon)",
      "ar-LY": "Arabic (Libya)",
      "ar-MA": "Arabic (Morocco)",
      "ar-OM": "Arabic (Oman)",
      "ar-QA": "Arabic (Qatar)",
      "ar-SA": "Arabic (Saudi Arabia)",
      "ar-SY": "Arabic (Syria)",
      "ar-TN": "Arabic (Tunisia)",
      "ar-YE": "Arabic (Yemen)",
      "az": "Azeri (Latin)",
      "az-AZ": "Azeri (Latin) (Azerbaijan)",
      "az-AZ": "Azeri (Cyrillic) (Azerbaijan)",
      "be": "Belarusian",
      "be-BY": "Belarusian (Belarus)",
      "bg": "Bulgarian",
      "bg-BG": "Bulgarian (Bulgaria)",
      "bs-BA": "Bosnian (Bosnia and Herzegovina)",
      "ca": "Catalan",
      "ca-ES": "Catalan (Spain)",
      "cs": "Czech",
      "cs-CZ": "Czech (Czech Republic)",
      "cy": "Welsh",
      "cy-GB": "Welsh (United Kingdom)",
      "da": "Danish",
      "da-DK": "Danish (Denmark)",
      "de": "German",
      "de-AT": "German (Austria)",
      "de-CH": "German (Switzerland)",
      "de-DE": "German (Germany)",
      "de-LI": "German (Liechtenstein)",
      "de-LU": "German (Luxembourg)",
      "dv": "Divehi",
      "dv-MV": "Divehi (Maldives)",
      "el": "Greek",
      "el-GR": "Greek (Greece)",
      "en": "English",
      "en-AU": "English (Australia)",
      "en-BZ": "English (Belize)",
      "en-CA": "English (Canada)",
      "en-CB": "English (Caribbean)",
      "en-GB": "English (United Kingdom)",
      "en-IE": "English (Ireland)",
      "en-JM": "English (Jamaica)",
      "en-NZ": "English (New Zealand)",
      "en-PH": "English (Republic of the Philippines)",
      "en-TT": "English (Trinidad and Tobago)",
      "en-us": "English (United States)",
      "en-ZA": "English (South Africa)",
      "en-ZW": "English (Zimbabwe)",
      "eo": "Esperanto",
      "es": "Spanish",
      "es-AR": "Spanish (Argentina)",
      "es-BO": "Spanish (Bolivia)",
      "es-CL": "Spanish (Chile)",
      "es-CO": "Spanish (Colombia)",
      "es-CR": "Spanish (Costa Rica)",
      "es-DO": "Spanish (Dominican Republic)",
      "es-EC": "Spanish (Ecuador)",
      "es-ES": "Spanish (Castilian)",
      "es-ES": "Spanish (Spain)",
      "es-GT": "Spanish (Guatemala)",
      "es-HN": "Spanish (Honduras)",
      "es-MX": "Spanish (Mexico)",
      "es-NI": "Spanish (Nicaragua)",
      "es-PA": "Spanish (Panama)",
      "es-PE": "Spanish (Peru)",
      "es-PR": "Spanish (Puerto Rico)",
      "es-PY": "Spanish (Paraguay)",
      "es-SV": "Spanish (El Salvador)",
      "es-UY": "Spanish (Uruguay)",
      "es-VE": "Spanish (Venezuela)",
      "et": "Estonian",
      "et-EE": "Estonian (Estonia)",
      "eu": "Basque",
      "eu-ES": "Basque (Spain)",
      "fa": "Farsi",
      "fa-IR": "Farsi (Iran)",
      "fi": "Finnish",
      "fi-FI": "Finnish (Finland)",
      "fo": "Faroese",
      "fo-FO": "Faroese (Faroe Islands)",
      "fr": "French",
      "fr-BE": "French (Belgium)",
      "fr-CA": "French (Canada)",
      "fr-CH": "French (Switzerland)",
      "fr-FR": "French (France)",
      "fr-LU": "French (Luxembourg)",
      "fr-MC": "French (Principality of Monaco)",
      "gl": "Galician",
      "gl-ES": "Galician (Spain)",
      "gu": "Gujarati",
      "gu-IN": "Gujarati (India)",
      "he": "Hebrew",
      "he-IL": "Hebrew (Israel)",
      "hi": "Hindi",
      "hi-IN": "Hindi (India)",
      "hr": "Croatian",
      "hr-BA": "Croatian (Bosnia and Herzegovina)",
      "hr-HR": "Croatian (Croatia)",
      "hu": "Hungarian",
      "hu-HU": "Hungarian (Hungary)",
      "hy": "Armenian",
      "hy-AM": "Armenian (Armenia)",
      "id": "Indonesian",
      "id-ID": "Indonesian (Indonesia)",
      "is": "Icelandic",
      "is-IS": "Icelandic (Iceland)",
      "it": "Italian",
      "it-CH": "Italian (Switzerland)",
      "it-IT": "Italian (Italy)",
      "ja": "Japanese",
      "ja-JP": "Japanese (Japan)",
      "ka": "Georgian",
      "ka-GE": "Georgian (Georgia)",
      "kk": "Kazakh",
      "kk-KZ": "Kazakh (Kazakhstan)",
      "kn": "Kannada",
      "kn-IN": "Kannada (India)",
      "ko": "Korean",
      "ko-KR": "Korean (Korea)",
      "kok": "Konkani",
      "kok-IN": "Konkani (India)",
      "ky": "Kyrgyz",
      "ky-KG": "Kyrgyz (Kyrgyzstan)",
      "lt": "Lithuanian",
      "lt-LT": "Lithuanian (Lithuania)",
      "lv": "Latvian",
      "lv-LV": "Latvian (Latvia)",
      "mi": "Maori",
      "mi-NZ": "Maori (New Zealand)",
      "mk": "FYRO Macedonian",
      "mk-MK": "FYRO Macedonian (Former Yugoslav Republic of Macedonia)",
      "mn": "Mongolian",
      "mn-MN": "Mongolian (Mongolia)",
      "mr": "Marathi",
      "mr-IN": "Marathi (India)",
      "ms": "Malay",
      "ms-BN": "Malay (Brunei Darussalam)",
      "ms-MY": "Malay (Malaysia)",
      "mt": "Maltese",
      "mt-MT": "Maltese (Malta)",
      "nb": "Norwegian (Bokm?l)",
      "nb-NO": "Norwegian (Bokm?l) (Norway)",
      "nl": "Dutch",
      "nl-BE": "Dutch (Belgium)",
      "nl-NL": "Dutch (Netherlands)",
      "nn-NO": "Norwegian (Nynorsk) (Norway)",
      "ns": "Northern Sotho",
      "ns-ZA": "Northern Sotho (South Africa)",
      "pa": "Punjabi",
      "pa-IN": "Punjabi (India)",
      "pl": "Polish",
      "pl-PL": "Polish (Poland)",
      "ps": "Pashto",
      "ps-AR": "Pashto (Afghanistan)",
      "pt": "Portuguese",
      "pt-BR": "Portuguese (Brazil)",
      "pt-PT": "Portuguese (Portugal)",
      "qu": "Quechua",
      "qu-BO": "Quechua (Bolivia)",
      "qu-EC": "Quechua (Ecuador)",
      "qu-PE": "Quechua (Peru)",
      "ro": "Romanian",
      "ro-RO": "Romanian (Romania)",
      "ru": "Russian",
      "ru-RU": "Russian (Russia)",
      "sa": "Sanskrit",
      "sa-IN": "Sanskrit (India)",
      "se": "Sami (Northern)",
      "se-FI": "Sami (Northern) (Finland)",
      "se-FI": "Sami (Skolt) (Finland)",
      "se-FI": "Sami (Inari) (Finland)",
      "se-NO": "Sami (Northern) (Norway)",
      "se-NO": "Sami (Lule) (Norway)",
      "se-NO": "Sami (Southern) (Norway)",
      "se-SE": "Sami (Northern) (Sweden)",
      "se-SE": "Sami (Lule) (Sweden)",
      "se-SE": "Sami (Southern) (Sweden)",
      "sk": "Slovak",
      "sk-SK": "Slovak (Slovakia)",
      "sl": "Slovenian",
      "sl-SI": "Slovenian (Slovenia)",
      "sq": "Albanian",
      "sq-AL": "Albanian (Albania)",
      "sr-BA": "Serbian (Latin) (Bosnia and Herzegovina)",
      "sr-BA": "Serbian (Cyrillic) (Bosnia and Herzegovina)",
      "sr-SP": "Serbian (Latin) (Serbia and Montenegro)",
      "sr-SP": "Serbian (Cyrillic) (Serbia and Montenegro)",
      "sv": "Swedish",
      "sv-FI": "Swedish (Finland)",
      "sv-SE": "Swedish (Sweden)",
      "sw": "Swahili",
      "sw-KE": "Swahili (Kenya)",
      "syr": "Syriac",
      "syr-SY": "Syriac (Syria)",
      "ta": "Tamil",
      "ta-IN": "Tamil (India)",
      "te": "Telugu",
      "te-IN": "Telugu (India)",
      "th": "Thai",
      "th-TH": "Thai (Thailand)",
      "tl": "Tagalog",
      "tl-PH": "Tagalog (Philippines)",
      "tn": "Tswana",
      "tn-ZA": "Tswana (South Africa)",
      "tr": "Turkish",
      "tr-TR": "Turkish (Turkey)",
      "tt": "Tatar",
      "tt-RU": "Tatar (Russia)",
      "ts": "Tsonga",
      "uk": "Ukrainian",
      "uk-UA": "Ukrainian (Ukraine)",
      "ur": "Urdu",
      "ur-PK": "Urdu (Islamic Republic of Pakistan)",
      "uz": "Uzbek (Latin)",
      "uz-UZ": "Uzbek (Latin) (Uzbekistan)",
      "uz-UZ": "Uzbek (Cyrillic) (Uzbekistan)",
      "vi": "Vietnamese",
      "vi-VN": "Vietnamese (Viet Nam)",
      "xh": "Xhosa",
      "xh-ZA": "Xhosa (South Africa)",
      "zh": "Chinese",
      "zh-CN": "Chinese (S)",
      "zh-HK": "Chinese (Hong Kong)",
      "zh-MO": "Chinese (Macau)",
      "zh-SG": "Chinese (Singapore)",
      "zh-TW": "Chinese (T)",
      "zu": "Zulu",
      "zu-ZA": "Zulu (South Africa)"
    }
    //console.log(code)
    return languageCode[code]

  }

  findSegments() {
    const labels = this.state.videoLabels.shotLabelAnnotations;
    let array = []
    let videoDuration = this.player.getDuration()
    //   console.log({ videoDuration: videoDuration })
    labels.forEach(label => {
      label.segments.forEach(segment => {
        // console.log(segment)
        let object = {
          name: label.entity.description,
          startTime: parseFloat(`${segment.segment.startTimeOffset.seconds}.${segment.segment.startTimeOffset.nanos}` / videoDuration * 100),
          endTime: parseFloat(`${segment.segment.endTimeOffset.seconds}.${segment.segment.endTimeOffset.nanos}` / videoDuration * 100),
          confidence: segment.confidence
        }
        array.push(object)
      })
    })
    this.setState({ segmentData: array })
    this.segmentLabelAnnotations()
  }

  OnTimeLineClick(event) {
    if (event.target.className != "ems_timeline-tag-marker") {
      console.log({ target: event.target })
      var bounds = event.target.getBoundingClientRect();
      var x = event.clientX - bounds.left;
      let seekTo = x / event.target.offsetWidth
      //console.log({ x: x / event.target.offsetWidth, bounds })

      this.player.seekTo(parseFloat(seekTo))
      this.setState({ played: `${seekTo * 100}%` })
      // return {x: x, y: y};
    }

  }

  gotoSingleLabel(seekTo) {
    // console.log({ object })
    // let videoDuration = this.player.getDuration()
    // let seekTo = object.segments[0].startTime / videoDuration

    this.player.seekTo(parseFloat(seekTo))
    this.player.playing = true
    this.setState({ played: `${seekTo * 100}%` })
  }

  gotoLabel(object) {
    console.log({ object })
    let videoDuration = this.player.getDuration()
    let seekTo = object.segments[0].startTime / videoDuration

    if (this.state.played > (seekTo * 100)) {
      object.segments.every(segment => {
        if (this.state.played > (segment.startTime / videoDuration) * 100) {
          return true
        } else {
          seekTo = segment.startTime / videoDuration
          return false
        }
      })

    }


    // let seekTo = (object.segments[0].startTime / videoDuration)
    // console.log({ object, videoDuration, seekTo: seekTo * 100, played: this.state.played, above: (this.state.played > (seekTo * 100)) })
    this.player.seekTo(parseFloat(seekTo))
    this.player.playing = true
    this.setState({ played: `${seekTo * 100}%` })
  }

  buildLabelDataData() {
    let confidenceCutOff = this.confidenceCutOff
    let videoLabelTags = []
    let labelsDetailed = []
    let labelObjects = []
    // console.log( this.state.videoLabels )
    // console.log(this.state.videoLabels.length)
    if (this.state.videoLabels != "nodata" && this.state.videoLabels != "loadingData") {
      this.state.videoLabels.shotLabelAnnotations.sort(this.sortLabelsAlphabeticly).forEach(obj => {
        //  console.log({ obj })
        // testData.shotLabelAnnotations.forEach(obj => {
        let object = {
          segments: [],
          confidence: 0
        }
        object.description = obj.entity.description

        obj.segments.forEach(segment => {
          if (segment.confidence > object.confidence) object.confidence = segment.confidence

          // console.log({ segment })
          // console.log({ segment: segment.segment })
          let newSegment = {}
          if (segment.segment.startTimeOffset.seconds != undefined) {
            let startTime = parseFloat(`${segment.segment.startTimeOffset.seconds}.${segment.segment.startTimeOffset.nanos}`)
            newSegment.startTime = startTime

            object.startTime = startTime
          } else {
            newSegment.startTime = 0
          }

          newSegment.endTime = `${segment.segment.endTimeOffset.seconds}.${segment.segment.endTimeOffset.nanos}`
          newSegment.confidence = segment.confidence
          object.segments.push(newSegment)
        })
        //  console.log({ object })

        const showing = this.state.selectedArray.includes(object.description)

        let className = showing ? 'ems_tag on_timeline' : 'ems_tag';

        if (this.state.labelsOnScreen.includes(object.description)) {
          className = "ems_tag on_timeline active"
        }

        if (object.confidence >= confidenceCutOff) {
          labelObjects.push(object)
          videoLabelTags.push(
            <div className={className} confidenceScore={object.confidence} content={object.description} onClick={this.labelClicked.bind(this, object)}>
              {object.description}

              {/* <div className={className} active={true}  >{object.description} ( {`${object.confidence.toString().substring(2, 4)}.${object.confidence.toString().substring(4, 6)}%`} )

                        </div>
                        <button className="labelButton" onClick={this.gotoLabel.bind(this, object)}><FontAwesomeIcon icon={faPlayCircle} /></button>
                      */}
            </div>

          )
        }

      })
    }



    if (this.sortByConfidence) {
      videoLabelTags = videoLabelTags.sort(this.sortLabelsbyConfidenceUp)
    }
    //    console.log({ testData })
    // console.log(buildData)
    this.setState({ videoLabelTags, labelObjects }, () => {
      //this.buildDetailedLabels()
    });



  }

  segmentLabelAnnotations() {
    let segmentLabels = []
    let videoDuration = this.player.getDuration()
    let top = 100
    this.state.videoLabels.segmentLabelAnnotations.forEach((obj, index) => {
      top += 20
      obj.segments.forEach(segment => {
        let barStart = (parseFloat(`${segment.segment.startTimeOffset.seconds}.${segment.segment.startTimeOffset.nanos}`) / videoDuration) * 100 || 0
        let barEnd = (parseFloat(`${segment.segment.endTimeOffset.seconds}.${segment.segment.endTimeOffset.nanos}`) / videoDuration) * 100
        let barWidth = (barEnd - barStart)
        //   console.log({ name: obj.entity.description, barStart, barEnd, barWidth, videoDuration })

        segmentLabels.push(
          <div className="labelBoxSegment" id={obj.entity.description} style={{ width: `${barWidth}%`, top: `${top}%`, left: `${barStart}%`, background: this.generateRandomColor() }}>{obj.entity.description}</div>
        )

      })


    })
    this.setState({ segmentLabels })
  }

  labelDelete(object) {
    let timeLineLabels = this.state.timeLineLabels.filter(function (obj) {
      return obj.props.id !== object.description
    })

    let selectedArray = this.state.selectedArray.filter(function (obj) {
      return obj !== object.description
    })

    this.setState({
      timeLineLabels,
      selectedArray,
    }, () => {
      this.buildLabelDataData()
    });
  }

  setSortBy(event) {
    this.sortBy = event.target.value
  }

  labelClicked(object) {
    let selectedArray = this.state.selectedArray
    let deletingLabel = false

    let check = document.getElementById(object.description)
    let videoDuration = this.player.getDuration()

    let timeLineLabels = Array.from(this.state.timeLineLabels)
    // let amount = document.getElementsByClassName("timelineLabelHolder").length
    // let topMargin = 20 * amount
    let segments = []
    object.segments.forEach(segment => {
      let barStart = (segment.startTime / videoDuration) * 100
      let barEnd = (segment.endTime / videoDuration) * 100
      let barWidth = (barEnd - barStart)
      if (check == null) {
        segments.push(
          <div className="ems_timeline-tag-marker" onClick={this.gotoSingleLabel.bind(this, (segment.startTime / videoDuration))} id={object.description} style={{ width: `${barWidth}%`, left: `${barStart}%` }}></div>
        )
      } else {
        deletingLabel = true
        this.labelDelete(object)
      }
    })
    if (check == null && !deletingLabel) {
      let rjlkjeturn = <div className="ems_timeline-tag" id={object.description}>
        {segments}
        <div className="ems_timeline-tag-name">
          {object.description}
        </div>
      </div>
      timeLineLabels.push(rjlkjeturn)
      selectedArray.push(object.description)
      let timelineHeight = 20 * timeLineLabels.length


      this.setState({ timeLineLabels, selectedArray, timelineHeight })
      //   console.log({ selectedArray: this.state.selectedArray })
      this.buildLabelDataData()
    }





  }

  generateRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }


  sortButton(e) {
    this.toggleClass('sort1', 'ems_toggle')
    let videoLabelTags


    if (this.sortBy === "Confidence") {
      if (e.target.className.includes("ems_toggle")) {
        videoLabelTags = [].concat(this.state.videoLabelTags).sort((a, b) => (a.props.confidenceScore > b.props.confidenceScore) ? 1 : -1)
      } else {
        videoLabelTags = [].concat(this.state.videoLabelTags).sort((a, b) => (a.props.confidenceScore < b.props.confidenceScore) ? 1 : -1)
      }
    } else if (this.sortBy === "Alphabetically") {
      if (e.target.className.includes("ems_toggle")) {
        videoLabelTags = [].concat(this.state.videoLabelTags).sort((a, b) => (a.props.content < b.props.content) ? 1 : -1)
      } else {
        videoLabelTags = [].concat(this.state.videoLabelTags).sort((a, b) => (a.props.content > b.props.content) ? 1 : -1)
      }
    }
    console.log({ sortby: this.sortBy, videoLabelTags })
    this.setState({ videoLabelTags })
  }

  componentWillUpdate(nextProps, nextState) {
  }

  clearAll() {
    this.setState(
      {
        timeLineLabels: <></>,
        selectedArray: [],
        timelineHeight: 20
      }, () => {
        this.buildLabelDataData()
      });

  }
  toggleTimeline() {
    console.log(this.state.showTimeline)
    if (this.state.showTimeline === false) {
      this.setState({ showTimeline: true });
    } else {
      this.setState({ showTimeline: false });
    }
  }


  sortLabelsAlphabeticly(a, b) {
    if (a.entity.description < b.entity.description) {
      return -1;
    }
    if (a.entity.description > b.entity.description) {
      return 1;
    }
    return 0;
  }

  toggleClass(target, className, event) {
    let newState = this.state[target]

    if (newState.includes(className)) {
      newState = newState.replace(` ${className}`, "")
      console.log({ newState, className })

    } else {
      newState = `${newState} ${className}`
    }
    this.setState({ [target]: newState });
    console.log({ [target]: newState })
  }

  toggleClassTranscript(target, className, event) {
    let newState = this.state[target]
    this.buildDetailedTranscript()
    if (newState.includes(className)) {
      newState = newState.replace(` ${className}`, "")
      console.log({ newState, className })

    } else {
      newState = `${newState} ${className}`
    }
    this.setState({ [target]: newState });
    console.log({ [target]: newState })
  }

  toggleClassTags(target, className, event) {
    let newState = this.state[target]
    this.buildDetailedLabels()

    if (newState.includes(className)) {
      newState = newState.replace(` ${className}`, "")
      console.log({ newState, className })

    } else {
      newState = `${newState} ${className}`
    }
    this.setState({ [target]: newState });
    console.log({ [target]: newState })
  }

  sortLabelsbyConfidenceUp(a, b) {
    if (a.props.confidenceScore > b.props.confidenceScore) {
      return -1;
    }
    if (a.props.confidenceScore < b.props.confidenceScore) {
      return 1;
    }
    return 0;
  }


  rangeChanged(data) {
    let videoDuration = this.player.getDuration()

    let rangeSelected = (((data[1] - data[0]) * videoDuration) / 100)
    let startRange = (data[0] * videoDuration) / 100
    let endRange = (data[1] * videoDuration) / 100
    console.log({ data, videoDuration, rangeSelected, startRange, endRange, startSec: this.sec2time(startRange), endSec: this.sec2time(endRange) })
    this.setState({ rangeStartTime: startRange, rangeEndTime: endRange, rangeSelected: rangeSelected })
    window.video = {}
    window.video.startCut = this.sec2time(startRange)
    window.video.endCut = this.sec2time(endRange)
    this.player.seekTo(startRange)
  }





  toggleParent(className, event) {
    if (!event.target.parentNode.classList.value.includes(className)) {
      event.target.parentNode.classList.add(className)
    } else {
      event.target.parentNode.classList.remove(className)
    }
  }

  playerReady(data) {

    if (this.state.rangeEndTime === 0) {
      let videoDuration = this.player.getDuration()
      this.setState({
        rangeEndTime: videoDuration,
        rangeSelected: videoDuration,
        videoDuration: videoDuration
      })
    }
  }

  sliderChange(data) {
    this.confidenceCutOff = data / 100
    this.buildLabelDataData()
    //this.buildDetailedLabels()
  }

  updateConfidenceCutoff(data) {
    this.confidenceCutOff = data / 100
    console.log(data)
    this.setState({ confidenceCutOff: data / 100 })
  }

  render() {
    //  console.log({ numberofmarks: this.state.videoDuration / 5 })
    let numberOfMarks = (this.state.videoDuration / 5)
    let marks = {}

    for (let step = 0; step < 100; step += 100 / numberOfMarks) {
      marks[step] = ""
    }



    return (

      <div className="ems_container" style={{ width: "70%" }}>
        <div className="ems_content_surface">
          <div className="ems_header_block ems_content_header">
            <span className="ems_content_type">{this.state.asset.assetDomain}</span>
            <span className="ems_header_title ems_content_title">{this.state.asset.metadata.title}</span>
          </div>
          {/* <ReactTooltip place="bottom" type="info" effect="solid" /> */}

          <div className="ems_content_workspace">




            <div className="ems_visual-wrapper">
              <div className="ems_video_wrapper">
                <ReactPlayer className='ems_video_player'
                  ref={this.ref}
                  url={window.elvisContext.activeTab.assetSelection[0].previewUrl}
                  controls={true}
                  onStart={this.findSegments.bind(this)}
                  onProgress={this.videoProgress.bind(this)}
                  onReady={this.playerReady.bind(this)}
                  progressInterval={50}
                  width='100%'
                  height='100%'
                />
              </div>
            </div>

            <div className="ems_info-wrapper">

              <div className={this.state.showTimeline ? "ems_timeline-wrapper" : "ems_timeline-wrapper hide"}>

                <Slider
                  range
                  className="ems_timeline-range-marker"
                  step={0.1}
                  marks={marks}
                  trackClassName=""
                  defaultValue={[0, 100]}
                  ariaLabel={['Lower thumb', 'Upper thumb']}
                  ariaValuetext={state => `Thumb value ${state.valueNow}`}
                  renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                  trackStyle={{ backgroundColor: "#e690ff" }}
                  pearling
                  onAfterChange={this.rangeChanged.bind(this)}
                  minDistance={1}
                />
                <div className="ems_timeline-tag-wrapper" onClick={this.OnTimeLineClick.bind(this)}>
                  <div className="ems_timeline-title">Tags</div>
                  {this.state.timeLineLabels}
                  <div className="ems_timeline-marker" style={{ left: `${this.state.played}%` }}></div>
                  {/* <div className="ems_timeline-range-marker-left" style={{ left: "25%" }}></div>
                                    <div className="ems_timeline-range-marker" style={{ left: "25%", width: "35%" }}></div>
                                    <div className="ems_timeline-range-marker-right" style={{ left: "60%" }}></div> */}

                </div>

                {/* <div className="segmentLabelContainer">
                                    {this.state.segmentLabels}
                                </div> */}
              </div>

              <div className="ems_timeline-transcript-wrapper">
                <div className="ems_timeline-title">Transcript</div>
                <div className="ems_timeline-transcript">
                  {this.state.transcriptionText}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    )
  }

}



Video.propTypes = {
  data: PropTypes.object,
};

export default Video